module.exports = __webpack_public_path__ + "img/prtr_footer_black.23bc1289.png";